import config from '../../../config/config';
import getRequest from '../base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the charging point list with pagination
   * @param {any} query - The query
   * @returns {Promise<any>} Response promise
   */
  fetchPersonalChargerList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.emsp.DriversApiUrl}api/emsp/v1/personal-charging-points`, {
      ...parameters,
    });
  },
  /**
   * Fetch personal charger details by chargingPointSn or ID
   * @param {string} chargingPointSn - The charging point serial number or ID
   * @returns {Promise<any>} Response promise
   */
  getPersonalChargingPointById: (chargingPointSn: string): Promise<any> => {
    return getRequest(
      `${config.emsp.DriversApiUrl}api/emsp/v1/personal-charging-points/${chargingPointSn}`,
    );
  },
  /**
   * Fetch the charging point list with pagination
   * @param {any} query - The query
   * @returns {Promise<any>} Response promise
   */
  fetchPersonalChargerListExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.emsp.DriversApiUrl}api/emsp/v1/personal-charging-points/export`, {
      ...parameters,
    });
  },
  /**
   * Fetch the charging point filter list
   * @returns {Promise<any>} Response promise
   */
  fetchPersonalChargerFilterList: (): Promise<any> => {
    return getRequest(
      `${config.emsp.DriversApiUrl}api/emsp/v1/personal-charging-points/list-filters`,
    );
  },
  /**
   * Fetch the charging point list without pagination
   * @param {any} data - The data
   * @returns {Promise<any>} Response promise
   */
  fetchPersonalChargerWithoutPagination: (data: any): Promise<any> => {
    return getRequest(`${config.emsp.DriversApiUrl}api/emsp/v1/personal-charging-points`, {
      ...data,
    });
  },
};
